import getFunctionData from "../../../utils/get-function-data";
import extractFirstLevelSpaces from "../../../utils/process-dataset/extract-first-level-spaces";
import processInitialValues from "./process-initial-values";

/**
 *
 * @param {String} input
 * @param {String} extracted
 * @param {AliasDefinitionMapProps} definition
 * @param {String} replacement
 * @param {Array<String>} store
 * @param {AliasProcessingProps} global
 * @returns {AliasProcessingProps}
 */
const processAliasParameters = (
  input,
  extracted,
  definition,
  replacement,
  store,
  global
) => {
  let result = "";
  let initials = /** @type {Array<String>} */ ([]);

  const globalResult = /** @type {Array<String>} */ (global.get("result"));
  const globalInitials = /** @type {Array<String>} */ (global.get("initials"));

  /** Full match including parenthesis */
  const match = extracted;

  /** Alias data */
  const data = getFunctionData(match);

  /** Possible alias custom value and options */
  const parameters = /** @type {String} */ (data.get("parameters"));

  const initialValues = /** @type {Array<String>} */ (
    definition.get("I") || null
  );
  const defaultValue = /** @type {String} */ (definition.get("V") || "");
  const defaultOptions = /** @type {String} */ (definition.get("O") || "");
  const defaultCustomValue = /** @type {AliasCustomValueProps} */ (
    definition.get("CV") || ""
  );

  const split = parameters.split("<");
  const userValue = split[0] ? split[0] : "";
  const userOptions = split[1] ? split[1].slice(0, -1) : "";
  const customParameters = /** @type {String} */ (definition.get("T") || "");

  /**
   * Replace initial values with the custom value
   */
  if (initialValues) {
    initials = processInitialValues(
      initialValues,
      defaultValue,
      userValue,
      userOptions,
      globalInitials
    );
  }

  /**
   * Replace values
   */
  if (userValue) {
    result = replacement.replace(/«V»/g, userValue);
  } else {
    result = replacement.replace(/«V»/g, defaultValue);
  }

  /**
   * Replace custom values
   */
  if (defaultCustomValue) {
    const customName = /** @type {String} */ (defaultCustomValue.get("name"));
    const extracted = extractFirstLevelSpaces(userOptions);
    const match = extracted.filter((item) => item.startsWith(customName))?.[0];
    const customValue = match ? match.replace(/\),/, ")") : null;

    if (customValue) {
      result = result.replace(/«CV»/g, customValue.split(":")[1] || "");
    } else {
      result = result.replace(/«CV»/g, defaultCustomValue.get("value") || "");
    }
  }

  /**
   * Replace options
   */
  if (userOptions) {
    result = result.replace(/«O»/g, userOptions);
  } else {
    result = result.replace(/«O»/g, defaultOptions);
  }
  /**
   * Finally, replace the original string (with trigger) with the processed alias
   */
  if (globalResult) {
    result = globalResult[0].replace(match, result);
  } else {
    result = input.replace(match, result);
  }

  /**
   * Custom trigger parameters
   */
  if (customParameters) {
    const exec = /^(\w*:|\w.*\):)/.exec(result);

    if (exec) {
      const trigger = exec[0];

      /** No parameters */
      if (trigger.endsWith("):")) {
        result = result.replace("):", `,${customParameters}):`);
      } else {
        result = result.replace(
          trigger,
          `${trigger.slice(0, -1)}(${customParameters}):`
        );
      }
    }
  }

  const map = new Map();

  store.push(result);

  map.set("initials", initials);
  map.set("result", store);

  return map;
};

export default processAliasParameters;
